import { Routes } from '@angular/router';
import { loginRoutes } from '@softapps/allgemein/login';
import { settingsRoutes } from '@softapps/allgemein/utils';
import { passwordRoutes } from '@softapps/allgemein/password';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { bestellvorschlagRoutes } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungRoutes } from '@softapps/mde/bestellerfassung';
import { etikettendruckRoutes } from '@softapps/mde/etikettendruck';
import { retourenRoutes } from '@softapps/mde/retouren';
import { warenverprobungRoutes } from '@softapps/mde/warenverprobung';
import { artikelInfoRoutes } from '@softapps/wws/artikel-info';
import { einseitigeLagerbuchungRoutes } from '@softapps/mde/einseitige-lagerbuchung';
import { gesamtabfrageRoutes } from '@softapps/wws/gesamtabfrage';
import { orderRoutes } from '@softapps/werkstatt/order';
import { vehicleRoutes } from '@softapps/werkstatt/vehicle';
import { mdeInventoryRoutes } from '../../../../../../libs/softapps/mde/inventory/src/lib/inventory.routes';

export const shellRoutes: Routes = [
  ...moduleRoutes,
  ...settingsRoutes,

  // MDE
  ...bestellvorschlagRoutes,
  ...bestellerfassungRoutes,
  ...etikettendruckRoutes,
  ...mdeInventoryRoutes,
  ...retourenRoutes,
  ...warenverprobungRoutes,
  ...artikelInfoRoutes,

  ...einseitigeLagerbuchungRoutes,
  ...gesamtabfrageRoutes,
  ...einseitigeLagerbuchungRoutes,
  ...vehicleRoutes,

  ...orderRoutes,
];

export const publicRoutes: Routes = [
  ...loginRoutes,
  ...passwordRoutes,
  ...settingsRoutes,
];
